import React from 'react'
import styled from '@emotion/styled/macro'
import { useTranslation } from 'react-i18next'

import { useMediaMin } from 'mediaQuery'
import { EMPTY_ADDRESS } from '../../utils/records'
import { DNSREGISTRAR_ADDRESS } from '../../utils/utils'

import { Title } from '../Typography/Basic'
import TopBar from '../Basic/TopBar'
// import DefaultFavourite from '../AddFavourite1/Favourite'
import NameDetails from './NameDetails'
import DNSNameRegister from './DNSNameRegister'
import ShortName from './ShortName'
import Tabs from './Tabs'
import { useAccount } from '../QueryAccount'
import NameContainer from '../Basic/MainContainer'
import Copy from '../CopyToClipboard/'
import useNetworkInfo from '../NetworkInformation/useNetworkInfo'

const Owner = styled('div')`
  color: #ccd4da;
  margin-right: 20px;
`

const RightBar = styled('div')`
  display: flex;
  align-items: center;
`

// const Favourite = styled(DefaultFavourite)``

function isRegistrationOpen(available, parent, isDeedOwner) {
  return (
    parent === process.env.REACT_APP_REGISTRAR_TLD && !isDeedOwner && available
  )
}

function isDNSRegistrationOpen(domain) {
  return !!domain.isDNSRegistrar
}

function isOwnerOfDomain(domain, account) {
  if (domain.owner !== EMPTY_ADDRESS && !domain.available) {
    return domain.owner.toLowerCase() === account.toLowerCase()
  }
  return false
}

function isOwnerOfParentDomain(domain, account) {
  if (domain.parentOwner !== EMPTY_ADDRESS) {
    return domain.parentOwner.toLowerCase() === account.toLowerCase()
  }
  return false
}

function Name({ details: domain, name, pathname, type, refetch, contentData }) {
  const { networkId } = useNetworkInfo()
  const { t } = useTranslation()
  const smallBP = useMediaMin('small')
  const percentDone = 0
  const account = useAccount()
  const isOwner = isOwnerOfDomain(domain, account)
  const isOwnerOfParent = isOwnerOfParentDomain(domain, account)
  let ownerType,
    registrarAddress = domain.parentOwner
  const isDeedOwner = domain.deedOwner === account
  const isRegistrant = !domain.available && domain.registrant === account
  const registrationOpen = isRegistrationOpen(
    domain.available,
    domain.parent,
    isDeedOwner
  )

  const preferredTab = registrationOpen ? 'register' : 'details'

  if (isDeedOwner || isRegistrant) {
    ownerType = 'Registrant'
  } else if (isOwner) {
    ownerType = 'Controller'
  }
  let containerState
  if (isDNSRegistrationOpen(domain)) {
    containerState = 'Open'
    if (networkId === 1) {
      registrarAddress = DNSREGISTRAR_ADDRESS
    }
  } else {
    containerState = isOwner ? 'Yours' : domain.state
  }
  console.log('***Name', {
    networkId,
    containerState
  })

  return (
    <>
      <TopBar>
        <Tabs
          pathname={pathname}
          tab={preferredTab}
          domain={domain}
          parent={domain.parent}
          account={account}
          registerTabText={contentData?.registerbutton?.title}
          detailsTabText={contentData?.detailsButton?.title}
        />
      </TopBar>
      {isDNSRegistrationOpen(domain) ? (
        <DNSNameRegister
          domain={domain}
          registrarAddress={registrarAddress}
          pathname={pathname}
          refetch={refetch}
          account={account}
          readOnly={account === EMPTY_ADDRESS}
        />
      ) : type === 'short' && domain.owner === EMPTY_ADDRESS ? ( // check it's short and hasn't been claimed already
        <ShortName name={name} />
      ) : (
        <NameDetails
          tab={preferredTab}
          domain={domain}
          pathname={pathname}
          name={name}
          isOwner={isOwner}
          isOwnerOfParent={isOwnerOfParent}
          refetch={refetch}
          account={account}
          registrationOpen={registrationOpen}
          contentData={contentData}
        />
      )}
    </>
  )
}

export default Name
